module.exports = __webpack_public_path__ + "static/media/bill.e294daac.png";